import { AudienceTargetingIcon } from 'foundations-assets/icons/components/AudienceTargetingIcon';
import { CodeIcon } from 'foundations-assets/icons/components/CodeIcon';
import { ConditionalIcon } from 'foundations-assets/icons/components/ConditionalIcon';
import { CustomObjectIcon } from 'foundations-assets/icons/components/CustomObjectIcon';
import { DateIcon } from 'foundations-assets/icons/components/DateIcon';
import { DelayIcon } from 'foundations-assets/icons/components/DelayIcon';
import { DescriptionIcon } from 'foundations-assets/icons/components/DescriptionIcon';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { IntegrationsIcon } from 'foundations-assets/icons/components/IntegrationsIcon';
import { IntegrationsSalesForceIcon } from 'foundations-assets/icons/components/IntegrationsSalesForceIcon';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { NextIcon } from 'foundations-assets/icons/components/NextIcon';
import { NotificationIcon } from 'foundations-assets/icons/components/NotificationIcon';
import { RefreshIcon } from 'foundations-assets/icons/components/RefreshIcon';
import { RotateLeadsIcon } from 'foundations-assets/icons/components/RotateLeadsIcon';
import { ServerlessFunctionIcon } from 'foundations-assets/icons/components/ServerlessFunctionIcon';
import { SmsIcon } from 'foundations-assets/icons/components/SmsIcon';
import { SwitcherIcon } from 'foundations-assets/icons/components/SwitcherIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
import { TimeIcon } from 'foundations-assets/icons/components/TimeIcon';
export const MAX_VISIBLE_ICONS = 3;
export const DEFAULT_ACTION_TYPE_ICON_COLOR = 'fill-accent-orange-default';
export const ACTION_TYPE_ICON_MAP = {
  AB_TEST_BRANCH: {
    icon: ConditionalIcon,
    color: 'fill-accent-teal-default'
  },
  ADS_AUDIENCE_MEMBERSHIP: {
    icon: AudienceTargetingIcon,
    color: 'fill-accent-green-default'
  },
  ALTER_LIST_MEMBERSHIP: {
    icon: ListsIcon,
    color: 'fill-accent-blue-default'
  },
  CLASSIC_ALTER_LIST_MEMBERSHIP: {
    icon: ListsIcon,
    color: 'fill-accent-blue-default'
  },
  CLASSIC_ANCHORED_DELAY: {
    icon: DelayIcon,
    color: 'fill-accent-orange-default'
  },
  CLASSIC_COPY_COMPANY_PROPERTY: {
    icon: DuplicateIcon,
    color: 'fill-accent-blue-default'
  },
  CLASSIC_ENROLL_IN_WORKFLOW: {
    icon: NextIcon,
    color: 'fill-accent-orange-default'
  },
  CLASSIC_NOTIFICATION_EMAIL: {
    icon: EmailIcon,
    color: 'fill-accent-purple-default'
  },
  CLASSIC_VIRTUAL_ANCHORED_DELAY: {
    icon: DateIcon,
    color: 'fill-accent-orange-default'
  },
  CRITERIA_BRANCH: {
    icon: ConditionalIcon,
    color: 'fill-accent-teal-default'
  },
  CUSTOM_CODE: {
    icon: CodeIcon,
    color: 'fill-accent-purple-default'
  },
  CREATE_OBJECT: {
    icon: CustomObjectIcon,
    color: 'fill-accent-green-default'
  },
  CREATE_SALESFORCE_CAMPAIGN: {
    icon: IntegrationsSalesForceIcon,
    color: 'fill-accent-blue-default'
  },
  CREATE_SALESFORCE_TASK: {
    icon: IntegrationsSalesForceIcon,
    color: 'fill-accent-blue-default'
  },
  DELAY: {
    icon: DelayIcon,
    color: 'fill-accent-orange-default'
  },
  DELAY_UNTIL_DATE: {
    icon: DelayIcon,
    color: 'fill-accent-orange-default'
  },
  EMAIL: {
    icon: EmailIcon,
    color: 'fill-accent-purple-default'
  },
  EMAIL_NOTIFICATION: {
    icon: EmailIcon,
    color: 'fill-accent-purple-default'
  },
  ENROLL_IN_FLOW: {
    icon: NextIcon,
    color: 'fill-accent-orange-default'
  },
  EXTENSION: {
    icon: IntegrationsIcon,
    color: 'fill-accent-blue-default'
  },
  FORMULA: {
    icon: ServerlessFunctionIcon,
    color: 'fill-accent-purple-default'
  },
  IN_APP_NOTIFICATION: {
    icon: NotificationIcon,
    color: 'fill-accent-teal-default'
  },
  INCREASE_PROPERTY: {
    icon: SwitcherIcon,
    color: 'fill-accent-blue-default'
  },
  LIST_BRANCH: {
    icon: ConditionalIcon,
    color: 'fill-accent-teal-default'
  },
  ROTATE_OBJECT: {
    icon: RotateLeadsIcon,
    color: 'fill-accent-green-default'
  },
  SEND_SMS_NOTIFICATION: {
    icon: SmsIcon,
    color: 'fill-accent-teal-default'
  },
  SET_PROPERTY: {
    icon: DescriptionIcon,
    color: 'fill-accent-blue-default'
  },
  SLACK_NOTIFICATION: {
    icon: NotificationIcon,
    color: 'fill-accent-teal-default'
  },
  STATIC_BRANCH: {
    icon: ConditionalIcon,
    color: 'fill-accent-teal-default'
  },
  TASK: {
    icon: TasksIcon,
    color: 'fill-accent-orange-default'
  },
  UPDATE_EMAIL_SUBSCRIPTION: {
    icon: ListsIcon,
    color: 'fill-accent-blue-default'
  },
  VIRTUAL_SCHEDULED_ENROLLMENT: {
    icon: TimeIcon,
    color: 'fill-accent-orange-default'
  },
  WAIT_UNTIL: {
    icon: DelayIcon,
    color: 'fill-accent-orange-default'
  },
  WEBHOOK: {
    icon: IntegrationsIcon,
    color: 'fill-accent-blue-default'
  },
  WHILE_LOOP: {
    icon: RefreshIcon,
    color: 'fill-accent-teal-default'
  }
};